import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// export const API = `${BACKEND_URL}/api`;
export const API = `http://13.232.112.135:5001/user_api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});



export const fetchRestaurants = () =>
  api.get("/resturant_list").then((r) => {
    const raw = r.data;
    const list = Array.isArray(raw)
      ? raw
      : raw?.resturant_list || raw?.restaurant_list || raw?.data || [];

    return list.map((item) => ({
      id: item.id ?? item._id,
      name: item.name,
      image: item.images?.[0] || item.image || "",
      rating: Number(item.avgRating ?? item.rating ?? 0),
      cuisine:
        Array.isArray(item.cuisines) && item.cuisines.length
          ? item.cuisines.join(", ")
          : item.cuisine || "Multi-cuisine",
      eta_min: parseInt(item.deliveryTime, 10) || item.eta_min || 0,
      price_for_two: item.avgPrice ?? item.price_for_two ?? 0,
      location: item.zoneName || item.location || "",
      tags: Array.isArray(item.tags) ? item.tags : [],
    }));
  });
export const fetchAnalytics = () => api.get("/analytics/summary").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
